import axiosClient from "./axios-client/axiosClient.jsx";

class PortfolioAPI {
  getDefaultPortfolio(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return axiosClient.get("/portfolio/get_default", headers);
  }

  getPortfolioBalances(token, portfolioName) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = { portfolio_name: portfolioName };

    return axiosClient.post(
      "/portfolio/get_portfolio_balances",
      requestBody,
      headers,
    );
  }

  getAllProducts(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return axiosClient.get("/portfolio/get_all_products", headers);
  }

  getTransactionHistory(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {};

    return axiosClient.post(
      "/portfolio/get_deep_portfolio_info",
      requestBody,
      headers,
    );
  }

  getTransactionHistoryPaginated(token, page, size) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };
    const requestBody = {};

    return axiosClient.post(
      "/portfolio/get_deep_portfolio_info_pageable?page=" +
        page +
        "&size=" +
        size,
      requestBody,
      headers,
    );
  }

  getTransactionHistoryForSymbol(token, portfolioName, symbol) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      portfolio_name: portfolioName,
      symbol: symbol,
    };

    return axiosClient.post(
      "/portfolio/portfolio_transactions_for_symbol",
      requestBody,
      headers,
    );
  }

  changeCurrencyFavorite(token, portfolioName, currency, enabled) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    const requestBody = {
      portfolio_name: portfolioName,
      base_currency: currency,
      enabled: enabled,
    };

    return axiosClient.post("/portfolio/portafolio_fav", requestBody, headers);
  }

  generateDailyFile(token, startDate, endDate) {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
        company: process.env.REACT_APP_COMPANY_HEADER,
      },
    };
    const requestBody = { startDate: startDate, endDate: endDate };

    var endpoint = "/portfolio/reports/generateDailyFile";

    return axiosClient.post(endpoint, requestBody, headers);
  }

  generateMonthlyReport(token, startDate, endDate, format, currencyClass) {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
        company: process.env.REACT_APP_COMPANY_HEADER,
      },
    };
    /* currency_class added per BACKEND_TERMINAL_SPEC_V3 §K.1. Sent
       only when the caller supplied it so the legacy "ALL" behavior
       is preserved when the body is omitted — do_no_harm for older
       BE builds that ignore unknown fields. */
    const requestBody = {
      fechaI: startDate,
      fechaF: endDate,
      format,
    };
    if (currencyClass) requestBody.currency_class = currencyClass;

    var endpoint = "/portfolio/reports/generateDetailPayments";

    return axiosClient.post(endpoint, requestBody, headers);
  }

  getSalesAgents(token) {
    const headers = {
      headers: { Authorization: `Bearer ${token}` },
    };

    return axiosClient.get("/portfolio/salesAgent/sale_agents", headers);
  }

  generateSalesAgentReport(token, month, year, salesId, format) {
    const headers = {
      headers: {
        Authorization: `Bearer ${token}`,
        company: process.env.REACT_APP_COMPANY_HEADER,
      },
    };
    const requestBody = {
      month,
      year,
      salesId,
      format,
    };

    var endpoint = "/portfolio/reports/generateSalesAgentReport";

    return axiosClient.post(endpoint, requestBody, headers);
  }
}

export const portfolioAPI = new PortfolioAPI();
